import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMtrSpecDetail(id) {
  const { data: raw } = await request.get(`/mtr-spec/${id}`);
  return parseVer4DetailResponse(raw);
}
